interface ResponseError {
    message?: string;
    [k: string]: any;
}

export const extractError = (action: any): ResponseError | null => {
    if (action.payload && typeof action.payload === 'object') return action.payload as ResponseError;
    if (action.error?.message) return { message: action.error?.message };

    return null;
};
